module.exports = __webpack_public_path__ + "img/gender_male.16780cd4.svg";